import React, { useEffect, useState } from "react";
import { AxiosResponse } from "axios";
import { ActivityToIcdsAxiosInstance } from "../../Network/ActivityToIcdsAxiosInstance";
import {
  RelationActivitytoIcd,
  Result,
  Payer,
} from "../../interface/ActivtyToIcds";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ColumnDef } from "@tanstack/react-table";
import { DataTable } from "shared/DataTable";
import { Button } from "../../components/ui/button";
import { Option } from "../../interface/Option";
import ListOfCustomActivities from "../Shared/ListOfActivities";
import ListOfCustomIcds from "../Shared/ListOfIcds";
import ListOfCustomIcdGroups from "../Shared/ListOIcdGroupingname";
import ListOfCustomActivityGroups from "../Shared/ListOfCustomActivityGroups";
import NetworkNames from "../Shared/NetworkNames";
import PolicyNames from "../Shared/PolicyNames";
import ActivitySelector from "../Shared/ActivityType"; // Import the ActivitySelector

const ActivityToIcdRelation: React.FC = () => {
  const [items, setItems] = useState<RelationActivitytoIcd>({ result: [] });
   const [listOfIcds, setlistOfIcds] = useState<string[]>([]);
  const [CustomIcdGroups, setCustomIcdGroups] = useState<string[]>([]);
  const [MedicalIcdGroups, setMedicalIcdGroups] = useState<string[]>([]);
 const [Activity, setActivity] = useState<string[]>([]);
  const [CustomActivityGroup, setCustomActivityGroup] = useState<string[]>([]);
  const [MedicalActivityGroup, setMedicalActivityGroup] = useState<string[]>(
    []
  );

  const [ExceptPayers, setExceptPayers] = useState<Payer>({
    id_payer: [],
    policy: [],
    networks: [],
    patients: [],
  });
  const [ForPayers, setForPayers] = useState<Payer>({
    id_payer: [],
    policy: [],
    networks: [],
    patients: [],
  });
  

  
  // const [Networks, setNetworks] = useState<string[]>([]);
  // const [Policy, setPolicy] = useState<string[]>([]);
  const [Patients, setPatients] = useState<string[]>([]);
  const token = localStorage.getItem('token') || "";
  const [editIndex, setEditIndex] = useState<null | number>(null);
  const [selectedActivities, setSelectedActivities] = useState<Option[]>([]);
  const [selectedIcds, setSelectedIcds] = useState<Option[]>([]);
  const [selectedCustomIcdGroups, setSelectedCustomIcdGroups] = useState<Option[]>([]);
  const [selectedCustomActivityGroups, setSelectedCustomActivityGroups] = useState<Option[]>([]);
  const [selectedNetworks, setSelectedNetworks] = useState<Option[]>([]);
  const [selectedPolicy, setSelectedPolicy] = useState<Option[]>([]);
  const [selectedActivityType, setSelectedActivityType] = useState<string>(""); // Track the selected activity type

  // ............................................. get data ...............................................
  const fetchItems = async (): Promise<void> => {
    try {
      const response: AxiosResponse<{ success: boolean; result: Result[] }> =
        await ActivityToIcdsAxiosInstance.get("geticd_activity");
      setItems({ result: [...response.data.result].sort((a: any, b: any) => b.id - a.id) });

      console.log(response.data.result);
    } catch (error) {
      console.error("Error fetching items:", error);
    }
  };
  //............................................. end get data ...............................................
  //............................................. add data ...............................................

  const addItem = async (): Promise<void> => {
    const activities = selectedActivities.map(option => option.value);
    const icds = selectedIcds.map(option => option.value);
    const Networks=selectedNetworks.map(option => option.label);
    const Policy=selectedPolicy.map(option => option.label);
    const CustomIcdsGroups = selectedCustomIcdGroups.map(option => option.label);
    const CustomActivitysGroups = selectedCustomActivityGroups.map(option => option.label);


    
    try {
      const newRelation = {
        icd: icds,
        custom_icd_groups: CustomIcdsGroups,
        medical_icd_groups: MedicalIcdGroups,
        activity: activities,
        custom_activity_group: CustomActivitysGroups,
        medical_activity_group: MedicalActivityGroup,
        except_payers: ExceptPayers,
        for_payers: ForPayers,
        Networks: Networks,
        policy: Policy,
        patients: Patients,
        token: token,
      };
      await ActivityToIcdsAxiosInstance.post("add", newRelation);
      fetchItems();
      setSelectedIcds([]);
      setSelectedCustomIcdGroups([]);
      setMedicalIcdGroups([]);
      // setActivity([]);
      setSelectedActivities([]);
      //setCustomIcdGroups([]);
      setSelectedCustomActivityGroups([]);
      setMedicalActivityGroup([]);
      setExceptPayers({
        id_payer: [],
        policy: [],
        networks: [],
        patients: [],
      });
      setForPayers({
        id_payer: [],
        policy: [],
        networks: [],
        patients: [],
      });
      setSelectedNetworks([]);
      setSelectedPolicy([]);
      setPatients([]);

      console.log("New group added successfully:", newRelation);

      console.log(items);
    } catch (error) {
      console.error("Error adding item:", error);
    }
  };

  //.............................................end add data ...............................................
  // ..................................................update data...............................
  const updateItem = async (id: string | number): Promise<void> => {
    try {
      const activities = selectedActivities.map(option => option.value);
      const icds = selectedIcds.map(option => option.value);
      const CustomIcdsGroups = selectedCustomIcdGroups.map(option => option.label);
      const CustomActivitysGroups = selectedCustomActivityGroups.map(option => option.label);
      const Networks=selectedNetworks.map(option => option.label);
      const Policy=selectedPolicy.map(option => option.label);

      const updatedItem = {
        icd: icds,
        custom_icd_groups: CustomIcdsGroups,
        medical_icd_groups: MedicalIcdGroups,
        activity: activities, 
        custom_activity_group: CustomActivitysGroups,
        medical_activity_group: MedicalActivityGroup,
        except_payers: ExceptPayers,
        for_payers: ForPayers,
        Networks: Networks,
        policy: Policy,
        patients: Patients,
        id: id,
        token: token,
      };

      await ActivityToIcdsAxiosInstance.put(`update`, updatedItem);
      fetchItems();
      setSelectedIcds([]);
      setSelectedCustomIcdGroups([]);
      setMedicalIcdGroups([]);
       setSelectedActivities([]);
      setSelectedCustomActivityGroups([]);
      setMedicalActivityGroup([]);
      setExceptPayers({
        id_payer: [],
        policy: [],
        networks: [],
        patients: [],
      });
      setForPayers({
        id_payer: [],
        policy: [],
        networks: [],
        patients: [],
      });
      setSelectedNetworks([]);
      setSelectedPolicy([]);
      setPatients([]);

      console.log("New group updated successfully:", updatedItem);
    } catch (error) {
      console.error("Error updating item:", error);
    }
  };

  //.............................................end update data ...............................................

  //............................................. remove data ...............................................

  const removeItem = async (id: string | number): Promise<void> => {
    try {
      await ActivityToIcdsAxiosInstance.delete(`delete/${id}`, {
       
         data: { token: token }, 
       });
      console.log(id);
      fetchItems();
    } catch (error) {
      console.error("Error removing item:", error);
    }
  };
  //.............................................end remove data ...............................................



    //--------------------------------------------Check Relation------------------------------------------------
    const CheckRelation = async (): Promise<void> => {
      try {
        const activities = selectedActivities.map(option => option.value);
        const icds = selectedIcds.map(option => option.value);
        const CustomIcdsGroups = selectedCustomIcdGroups.map(option => option.label);

        const CustomActivitysGroups = selectedCustomActivityGroups.map(option => option.label);

        const checkRelation = {
          icd: icds,
          custom_icd_groups: CustomIcdsGroups,
          medical_icd_groups: MedicalIcdGroups,
          activity: activities,
          custom_activity_group: CustomActivitysGroups,
          medical_activity_group: MedicalActivityGroup,
          token: token,
        };
    
        const response: AxiosResponse = await ActivityToIcdsAxiosInstance.post(
          "check-relation",
          checkRelation
        );
    
        // Extract data from the response
        const { relationExists } = response.data;
    
        // Display alert based on the response
      
        if (relationExists) {
          toast.error("Relation not allowed", {
            style: { backgroundColor: "#d9534f", color: "white" },
          });
        } else {
          toast.success("Relation allowed", {
            style: { backgroundColor: "#4caf50", color: "white" },
            
          });
        }
  
        fetchItems();
       /* setlistOfIcds([]);
        setCustomIcdGroups([]);
        setMedicalIcdGroups([]);
        setActivity([]);
        setCustomActivityGroup([]);
        setMedicalActivityGroup([]);*/
        setSelectedIcds([]);
        setSelectedCustomIcdGroups([]);
        setMedicalIcdGroups([]);
         setSelectedActivities([]);
        setSelectedCustomActivityGroups([]);
        setMedicalActivityGroup([]);
    
        console.log("Check Relation successfully:", checkRelation);
      } catch (error) {
        console.error("Error checking relation:", error);
      }
    };
  




  const handleActivitiesChange = (selectedOptions: Option[]) => {
    console.log("selected:", selectedOptions);
    setSelectedActivities(selectedOptions);
   
  };
  const handleIcdsChange = (selectedOptions: Option[]) => {
    console.log("selected:", selectedOptions);
    setSelectedIcds(selectedOptions);
  };

  const handleCustomIcdsGroupsChange = (selectedOptions: Option[]) => {
    console.log("selected:", selectedOptions);
    setSelectedCustomIcdGroups(selectedOptions);
  };
  const handleCustomActivityGroupsChange = (selectedOptions: Option[]) => {
    console.log("selected:", selectedOptions);
    setSelectedCustomActivityGroups(selectedOptions);
  };
  const handleNetworksChange = (selectedOptions: Option[]) => {
    console.log("selected:", selectedOptions);
    setSelectedNetworks(selectedOptions);
  };
  const handlePolicyChange = (selectedOptions: Option[]) => {
    console.log("selected:", selectedOptions);
    setSelectedPolicy(selectedOptions);
  };

  const handleActivityTypeChange = (selectedActivityType: string) => {
    setSelectedActivityType(selectedActivityType);
  };

  useEffect(() => {
    fetchItems();
  }, []);


  const resetForm = () => {
    setSelectedIcds([]);
    setSelectedCustomIcdGroups([]);
    setMedicalIcdGroups([]);
     setSelectedActivities([]);
    setSelectedCustomActivityGroups([]);
    setMedicalActivityGroup([]);
    setExceptPayers({
      id_payer: [],
      policy: [],
      networks: [],
      patients: [],
    });
    setForPayers({
      id_payer: [],
      policy: [],
      networks: [],
      patients: [],
    });
    setSelectedNetworks([]);
    setSelectedPolicy([]);
    setPatients([]);
    setEditIndex(null);

  };

 

  const handleEdit =  (item: Result) => {
    if (item) {
            
      const ICDS = (item.icd || []).map((icd: string) => ({
        label: icd,
        value: icd,
      }));
  
      setSelectedIcds(ICDS); 

      const CustomIcdsGroups = (item.custom_icd_groups || []).map((custom_icd_groups: string) => ({
        label:String (custom_icd_groups),
        value:String (custom_icd_groups),
      }));
  
      setSelectedCustomIcdGroups(CustomIcdsGroups)
      setMedicalIcdGroups(item.medical_icd_groups || []);
      const activities = (item.activity || []).map((activity: string) => ({
        label: activity,
        value: activity,
      }));
  
      setSelectedActivities(activities); 

      const CustomActivitysGroups = (item.custom_activity_group || []).map((custom_activity_group: string) => ({
        label: custom_activity_group,
        value: custom_activity_group,
      }));
      setSelectedCustomActivityGroups(CustomActivitysGroups);
      setMedicalActivityGroup(item.medical_activity_group || []);
      setForPayers({
        id_payer: item.for_payers?.id_payer || [],
        patients: item.for_payers?.patients || [],
        policy: item.for_payers?.policy || [], // Ensure policy is provided
        networks: item.for_payers?.networks || [], // Ensure networks are provided
      });


      setExceptPayers({
        id_payer: item.for_payers?.id_payer || [],
        patients: item.for_payers?.patients || [],
        policy: item.for_payers?.policy || [], // Ensure policy is provided
        networks: item.for_payers?.networks || [], // Ensure networks are provided
      });


      // Map Networks and Policy for Except Payers
      const exceptNetworks = (item.except_payers?.networks || []).map((network: string) => ({
        label: network,
        value: network,
      }));
      setSelectedNetworks(exceptNetworks);

      const exceptPolicy = (item.except_payers?.policy || []).map((policy: string) => ({
        label: policy,
        value: policy,
      }));
      setSelectedPolicy(exceptPolicy);

      // Map Networks and Policy for For Payers
      const forNetworks = (item.for_payers?.networks || []).map((network: string) => ({
        label: network,
        value: network,
      }));
      setSelectedNetworks(forNetworks);

      const forPolicy = (item.for_payers?.policy || []).map((policy: string) => ({
        label: policy,
        value: policy,
      }));
      setSelectedPolicy(forPolicy);
      const Networks = (item.icd || []).map((icd: string) => ({
        label: icd,
        value: icd,
      }));
      setSelectedNetworks(Networks);
      const Policy = (item.icd || []).map((icd: string) => ({
        label: icd,
        value: icd,
      }));
      setSelectedPolicy(Policy);
      
      setPatients(item.patients || []);
      setEditIndex(item.id);
  }
}
  const columns: ColumnDef<Result>[] = [
    {
      accessorKey: "id",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          ID
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
    },
    {
      accessorKey: "icd",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
ICDS
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
      cell: ({ row }) => {
        const icds = row.getValue("icd") as string[];
        return Array.isArray(icds) ? icds.join(", ") : icds;
      },
    },
    {
      accessorKey: "custom_icd_groups",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
CustomICDGroups
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
      cell: ({ row }) => {
        const CustomIcd = row.getValue("custom_icd_groups") as string[];
        return Array.isArray(CustomIcd) ? CustomIcd.join(", ") : CustomIcd;
      },
    },
    {
      accessorKey: "medical_icd_groups",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
MedicalICDGroups
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
      cell: ({ row }) => {
        const MedicalICD = row.getValue("medical_icd_groups") as string[];
        return Array.isArray(MedicalICD) ? MedicalICD.join(", ") : MedicalICD;
      },
    },
    {
      accessorKey: "activity_Type",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
 ActivityType
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
    },
  
 {
      accessorKey: "activity",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >Activity
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
      cell: ({ row }) => {
        const activities = row.getValue("activity") as string[];
        return Array.isArray(activities) ? activities.join(", ") : activities;
      },
    }
    ,
     {
      accessorKey: "custom_activity_group",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
CustomActivityGroup
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
      cell: ({ row }) => {
        const CustomActivity = row.getValue("custom_activity_group") as string[];
        return Array.isArray(CustomActivity) ? CustomActivity.join(", ") : CustomActivity;
      },
    },
    {
      accessorKey: "medical_activity_group",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
MedicalActivityGroup
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
      cell: ({ row }) => {
        const MedicalActivity = row.getValue("medical_activity_group") as string[];
        return Array.isArray(MedicalActivity) ? MedicalActivity.join(", ") : MedicalActivity;
      },
    },
    {
      accessorKey: "except_payers",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
ExceptPayers
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
      cell: ({ row }) => {
        const ExceptPayers = row.getValue("except_payers") as string[];
        return Array.isArray(ExceptPayers) ? ExceptPayers.join(", ") : ExceptPayers;
      },
    },
    {
      accessorKey: "for_payers",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
ForPayers
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
      cell: ({ row }) => {
        const ForPayers = row.getValue("for_payers") as string[];
        return Array.isArray(ForPayers) ? ForPayers.join(", ") : ForPayers;
      },
    },
    {
      accessorKey: "networks",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
Networks
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
      cell: ({ row }) => {
        const network = row.getValue("networks") as string[];
        return Array.isArray(network) ? network.join(", ") : network;
      },
    },
    {
      accessorKey: "policy",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
Policy
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
      cell: ({ row }) => {
        const Policy = row.getValue("policy") as string[];
        return Array.isArray(Policy) ? Policy.join(", ") : Policy;
      },
    },
    {
      accessorKey: "patients",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
Patients
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
      cell: ({ row }) => {
        const Patients = row.getValue("patients") as string[];
        return Array.isArray(Patients) ? Patients.join(", ") : Patients;
      },
    },
  ];
  return (
    <div className=" container" style={{ margin: "30px" }}>
      {/* title */}
      <h5>
        Activity To ICD TEST Screen{" "}
        <span>
          {" "}
          <i className="fa-solid fa-briefcase"></i>{" "}
        </span>{" "}
      </h5>
   
      {/* model */}
      {/* tabIndex="-1" */}
      <div
        className="modal fade"
        id="exampleModal"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog" style={{ marginLeft: "20%"}} >
          <div className="modal-content" style={{ width: "200%"}}>
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Add Item
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                {" "}
              </button>
            </div>

            <div className="container d-flex flex-column align-items-center">
        {/* ICDs Section */}
        <div className="row">
          <div className="col-md-4">
            <label className="m-2">ICD:</label>
            <div style={{ width: "120%"}}>
            <ListOfCustomIcds onChange={handleIcdsChange} />
            </div>
          </div>
          <div className="col-md-4">
            <label className="m-2">Custom ICD Groups:</label>
            <div style={{ width: "120%"}}>
            <ListOfCustomIcdGroups onChange={handleCustomIcdsGroupsChange} />
            </div>
          </div>
          <div className="col-md-4">
            <label className="m-2">Medical ICD Groups:</label>
            <input
              type="text"
              className="form-control"
              style={{ marginBottom: "10px" }}
              value={MedicalIcdGroups.join(",")}
              onChange={(e) => setMedicalIcdGroups(e.target.value.split(","))}
            />
          </div>
        </div>

        {/* Activities Section */}
      
        <div className="row">
          <div className="col-md-4">
            <label className="m-2">Activity Type:</label>
            <div style={{ width: "120%" }}>
              <ActivitySelector onSelectActivity={handleActivityTypeChange} />
            </div>
          </div>

          <div className="col-md-4">
            <label className="m-2">Activities:</label>
            <div style={{ width: "120%" }}>
              {/* Pass selectedActivityType to ListOfCustomActivities */}
              <ListOfCustomActivities
                onChange={handleActivitiesChange}
                selectedActivityType={selectedActivityType}
              />
            </div>
          </div>
     
          <div className="col-md-4">
            <label className="m-2">Custom Activity Group:</label>
            <div style={{ width: "120%"}}>
            <ListOfCustomActivityGroups onChange={handleCustomActivityGroupsChange} />          
              </div>
            </div>
          <div className="col-md-4">
            <label className="m-2">Medical Activity Group:</label>
            <input
              type="text"
              className="form-control"
              style={{ marginBottom: "10px" }}
              value={MedicalActivityGroup.join(",")}
              onChange={(e) => setMedicalActivityGroup([e.target.value])}
            />
          </div>
        </div>


        {/* Except Payers and For Payers Sections */}
<div className="row">
  {/* Except Payers Section */}
  <div className="col-md-6">
    <h5 className="m-2">Except Payers</h5>
    <div className="row">
      <div className="col-md-6">
        <label className="m-2">id_payer:</label>
        <input
          type="text"
          className="form-control"
          style={{ marginBottom: "10px" }}
          value={ExceptPayers.id_payer.join(",")}
          onChange={(e) => {
            const values = e.target.value.split(",").map((item) => Number(item.trim()));
            setExceptPayers((prevState) => ({
              ...prevState,
              id_payer: values,
            }));
          }}
        />
      </div>
      <div className="col-md-6">
        <label className="m-2">Policy:</label>
        <div style={{ width: "130%"}}>
            <PolicyNames onChange={handlePolicyChange} />         
            </div>
       {/* <input
          type="text"
          className="form-control"
          style={{ marginBottom: "10px" }}
          value={ExceptPayers.policy.join(",")}
          onChange={(e) => {
            const values = e.target.value.split(",").map((item) => item.trim());
            setExceptPayers((prevState) => ({
              ...prevState,
              policy: values,
            }));
          }}
        />*/}
      </div>
    </div>
  </div>

  {/* For Payers Section - Right Column */}
  <div className="col-md-6">
    <h5 className="m-2">For Payers</h5>
    <div className="row">
      <div className="col-md-6">
        <label className="m-2">id_payer:</label>
        <input
          type="text"
          className="form-control"
          style={{ marginBottom: "10px" }}
          value={ForPayers.id_payer.join(",")}
          onChange={(e) => {
            const values = e.target.value.split(",").map((item) => Number(item.trim()));
            setForPayers((prevState) => ({
              ...prevState,
              id_payer: values,
            }));
          }}
        />
      </div>
      <div className="col-md-6">
        <label className="m-2">Policy:</label>
        <div style={{ width: "130%"}}>
            <PolicyNames onChange={handlePolicyChange} />
            </div>
   {/*     <input
          type="text"
          className="form-control"
          style={{ marginBottom: "10px" }}
          value={ForPayers.policy.join(",")}
          onChange={(e) => {
            const values = e.target.value.split(",").map((item) => item.trim());
            setForPayers((prevState) => ({
              ...prevState,
              policy: values,
            }));
          }}
        />*/}
      </div>
    </div>
  </div>
</div>

<div className="row">
  {/* Except Payers Section - Left Column */}
  <div className="col-md-6">
    <div className="row">
      <div className="col-md-6">
        <label className="m-2">Networks:</label>
        <div style={{ width: "130%"}}>
            <NetworkNames onChange={handleNetworksChange} />
            </div> 
     {/*   <input
          type="text"
          className="form-control"
          style={{ marginBottom: "10px" }}
          value={ExceptPayers.networks.join(",")}
          onChange={(e) => {
            const values = e.target.value.split(",").map((item) => item.trim());
            setExceptPayers((prevState) => ({
              ...prevState,
              networks: values,
            }));
          }}
        />*/}
      </div>
      <div className="col-md-6">
        <label className="m-2">Patients:</label>
        <input
          type="text"
          className="form-control"
          style={{ marginBottom: "10px" }}
          value={ExceptPayers.patients.join(",")}
          onChange={(e) => {
            const values = e.target.value.split(",").map((item) => item.trim());
            setExceptPayers((prevState) => ({
              ...prevState,
              patients: values,
            }));
          }}
        />
      </div>
    </div>
  </div>

  {/* For Payers Section - Right Column */}
  <div className="col-md-6">
    <div className="row">
      <div className="col-md-6">
        <label className="m-2">Networks:</label>
        <div style={{ width: "130%"}}>
            <NetworkNames onChange={handleNetworksChange} />
            </div> 
  {/*      <input
          type="text"
          className="form-control"
          style={{ marginBottom: "10px" }}
          value={ForPayers.networks.join(",")}
          onChange={(e) => {
            const values = e.target.value.split(",").map((item) => item.trim());
            setForPayers((prevState) => ({
              ...prevState,
              networks: values,
            }));
          }}
        />*/}
      </div>
      <div className="col-md-6">
        <label className="m-2">Patients:</label>
        <input
          type="text"
          className="form-control"
          style={{ marginBottom: "10px" }}
          value={ForPayers.patients.join(",")}
          onChange={(e) => {
            const values = e.target.value.split(",").map((item) => item.trim());
            setForPayers((prevState) => ({
              ...prevState,
              patients: values,
            }));
          }}
        />
      </div>
    </div>
  </div>
</div>

         {/* Networks/Policy/Patients Section */}
         <div className="row">
          <div className="col-md-4">
            <label className="m-2">Networks:</label>
            <div style={{ width: "120%"}}>
            <NetworkNames onChange={handleNetworksChange} />
            </div>         
             </div>
          <div className="col-md-4">
            <label className="m-2">Policy:</label>
            <div style={{ width: "120%"}}>
            <PolicyNames onChange={handlePolicyChange} />
            </div>
          </div>
          <div className="col-md-4">
            <label className="m-2">Patients:</label>
            <input
              type="text"
              className="form-control"
              style={{ marginBottom: "10px" }}
              value={Patients.join(",")}
              onChange={(e) => setPatients([e.target.value])}
            />
          </div>
        </div>
      </div>


      <div className="modal-footer">
        <button
          type="button"
          className="btn btn-primary"
          onClick={editIndex === null ? addItem : () => updateItem(editIndex)}
        >
          {editIndex === null ? "Add Item" : "Update Item"}
        </button>
        <button
          type="button"
          className="btn btn-secondary"
          data-bs-dismiss="modal"
          onClick={resetForm}
        >
          Close
        </button>
      </div>
    </div>
  </div>
</div>

{/* tabIndex="-2" */}

<div
        className="modal fade"
        id="exampleModal2"
        aria-labelledby="exampleModalLabel2"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel2">
                Check Relation
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                {" "}
              </button>
            </div>

            <div className=" container d-flex flex-column align-items-center ">
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div style={{ marginBottom: "10px" }}>
                  <label className="m-2">ICD:</label>
                
           
                  <ListOfCustomIcds onChange={handleIcdsChange} />
{/*
                  <input
                    type="text"
                    className="form-control "
                    style={{ marginBottom: "10px" }}
                    aria-label="Recipient's username"
                    aria-describedby="basic-addon2"
                    value={listOfIcds.join(",")}
                    onChange={(e) => setlistOfIcds(e.target.value.split(","))}
                  />

*/}
                  <label className="m-2">Custom ICD Groups:</label>
                  <ListOfCustomIcdGroups onChange={handleCustomIcdsGroupsChange} />

{/*
                  <input
                    type="text"
                    className="form-control "
                    style={{ marginBottom: "10px" }}
                    aria-label="Recipient's username"
                    aria-describedby="basic-addon2"
                    value={CustomIcdGroups.join(",")}
                    onChange={(e) =>
                      setCustomIcdGroups(e.target.value.split(",").map(Number))
                    }
                  />*/}
                  <label className="m-2">Medical ICD Groups:</label>

                  <input
                    type="text"
                    className="form-control "
                    style={{ marginBottom: "10px" }}
                    aria-label="Recipient's username"
                    aria-describedby="basic-addon2"
                    value={MedicalIcdGroups.join(",")}
                    onChange={(e) =>
                      setMedicalIcdGroups(e.target.value.split(","))
                    }
                  />

                  <label className="m-2">Activity:</label>
                  
                  <ListOfCustomActivities  onChange={handleActivitiesChange} />

{/*
                  <input
                    type="text"
                    className="form-control "
                    style={{ marginBottom: "10px" }}
                    aria-label="Recipient's username"
                    aria-describedby="basic-addon2"
                    value={Activity.join(",")}
                    onChange={(e) => setActivity(e.target.value.split(","))}
                  />*/}
                  <label className="m-2"> Custom Activity Group:</label>
                  <ListOfCustomActivityGroups onChange={handleCustomActivityGroupsChange} />


          {/*       <input
                    type="text"
                    className="form-control "
                    style={{ marginBottom: "10px" }}
                    aria-label="Recipient's username"
                    aria-describedby="basic-addon2"
                    value={CustomActivityGroup.join(",")}
                    onChange={(e) =>
                      setCustomActivityGroup(
                        e.target.value.split(",").map(Number)
                      )
                    }
                  />*/}

                  <label className="m-2"> Medical Activity Group:</label>

                  <input
                    type="text"
                    className="form-control "
                    style={{ marginBottom: "10px" }}
                    aria-label="Recipient's username"
                    aria-describedby="basic-addon2"
                    value={MedicalActivityGroup.join(",")}
                    onChange={(e) => setMedicalActivityGroup([e.target.value])}
                  />
 </div>
              </div>
            </div>

            <div className="modal-footer">
            <button
  type="button"
  className="btn btn-primary"
  onClick={() => CheckRelation()} // Ensure checkRelation is a function
>  Check Relation
</button>
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="exampleModal2"
        aria-labelledby="exampleModalLabel2"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel2">
              Check Relation
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                {" "}
              </button>
            </div>

           

            <div className="modal-footer">
            <button
  type="button"
  className="btn btn-primary"
  onClick={() => CheckRelation()} // Ensure checkRelation is a function
>
  Check Relation
</button>
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>




      {/* table */}
     

<DataTable
  columns={columns}
  data={items.result}
  searchColumn="custom_icd_groups"
  addButtonLabel="Add New Relation" // Custom button text
  modalId="exampleModal" // Custom add modal ID
  showAddButton={true} // Control visibility
  onEdit={handleEdit}
  onDelete={removeItem}
/>
            <ToastContainer
   
   position="top-center"
   autoClose={5000}
   hideProgressBar={false}
   newestOnTop={false}
   closeOnClick
   rtl={false}
   pauseOnFocusLoss
   draggable
   pauseOnHover
 />

    </div>
  );
};
export default ActivityToIcdRelation;
